import React from 'react';
import styles from './play-button.module.scss';
import {PLAYERSTATUS} from "@/constants";

type Props = {
    player: HTMLAudioElement | undefined,
    playerStatus: string,
    setPlayerStatus: (s: string) => void,
    bgColor: string
};

const PlayButton: React.FC<Props> = ({ player, playerStatus, setPlayerStatus, bgColor }) => {

    const playPause = () => {
        try {
            if(PLAYERSTATUS.PLAYING === playerStatus) {
                player?.pause();
                setPlayerStatus(PLAYERSTATUS.PAUSED);
            }
            if(PLAYERSTATUS.PAUSED === playerStatus) {
                player?.play();
                setPlayerStatus(PLAYERSTATUS.PLAYING);
            }
            if(PLAYERSTATUS.REPEAT === playerStatus && player) {
                player.currentTime = 0;
                player?.play();
                setPlayerStatus(PLAYERSTATUS.PLAYING);
            }    
        } catch (e) { console.log(e); }
    }

    let shadowSize = 5;
    let scaleSize = 1;
    const hsla = Number(bgColor.substring("hsla(".length, bgColor.indexOf(',')));
    if(bgColor.startsWith("hsla(") && playerStatus === PLAYERSTATUS.PLAYING) {
        shadowSize = hsla / 120;
        scaleSize = 1 + shadowSize / 25; //Math.min(1 + shadowSize / 20, 1.15);
    }
    const shadowColor = playerStatus === PLAYERSTATUS.PLAYING ? `hsla(${Math.ceil((hsla % 360) / 60) * 60}, 100%, 50%)` : 'var(--bs-primary)';

    return (
        <button type="button" className={styles.playButton} style={{ boxShadow: `0 0 10px ${shadowSize}px ${shadowColor}`, transform: 'scale(' + scaleSize + ')' }} onClick={playPause}>
            {playerStatus === PLAYERSTATUS.PLAYING ? (
                <i className="fa fa-pause" />
            ):''}
            {playerStatus === PLAYERSTATUS.REPEAT ? (
                <i className="fa fa-repeat" />
            ):''}
            {playerStatus === PLAYERSTATUS.PAUSED || playerStatus === PLAYERSTATUS.TEMP_PAUSE ? (
                <i className="fa fa-play" />
            ):''}
            {playerStatus === PLAYERSTATUS.LOADING ? (
                <i className="fa fa-spinner fa-spin" />
            ):''}
        </button>
    );
}

export default PlayButton;
